import { createUseStyles } from 'react-jss';

export const useStyles = styles => createUseStyles(styles)();
